import styled from 'styled-components';
import {Column, Container, Row} from '../../assets/styledAssets/grid';
import {bpSm, white} from '../../assets/styledAssets/vars';
import bg from '../../assets/images/mainPic.png';

export const StyledColumn = styled(Column)`
  z-index:1;
  @media(min-width:${bpSm}){background-color: ${white};}
`;
export const StyledRow = styled(Row)`
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-position-x:center;
  background-size: auto 100%;
  position:relative;
  &:before{
    content:"";
    top:0;
    left:0;
    right:0;
    bottom:0;
    position:absolute;
    background-color:#000;
    opacity:.72;
    z-index:1;
  }
  @media(min-width:${bpSm}){
    background-position-x: right;
    &:before{display:none;}
  }
`;

export const StyledContainer = styled(Container)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
`;
